import React from "react";
import loadImage from "blueimp-load-image";
import Select from "react-select";
import _ from "lodash";

import {
  RetailerTypesOptions,
  Top10Options,
  RetailerPartToken,
  OfferRedemptionTypeOptions
} from "../../Constants/retailer";

import "./index.css";

const RetailerFullToken = [
  {
    value: 0,
    label: "N/A",
  },
  ..._.times(50, (number) => ({
    value: number + 1,
    label: `${number + 1}`,
  })),
];
class AddOfferModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      provider: "",
      info: {
        threshold: "",
        online: true,
        inStore: true,
        fullTokens: RetailerFullToken[0],
        partTokens: RetailerPartToken[0],
        tokenPercentage: null
      },
      membershipBenefit: "",
      brandHex: "",
      category: RetailerTypesOptions[0],
      top10: Top10Options[0],
      offerRedemptionType: OfferRedemptionTypeOptions[1]
    };
  }

  componentDidMount() {
    const { initialValue } = this.props;

    if (initialValue) {
      this.setState({
        provider: initialValue.name,
        membershipBenefit: initialValue.membershipBenefit || "",
        info:
          typeof initialValue.membershipBenefit === "object"
            ? {
                ...initialValue.membershipBenefit,
                fullTokens:
                  RetailerFullToken.find(
                    item =>
                      item.value === initialValue.membershipBenefit.fullTokens
                  ) || RetailerFullToken[0],
                partTokens:
                  RetailerPartToken.find(
                    item =>
                      item.value === initialValue.membershipBenefit.partTokens
                  ) || RetailerPartToken[0]
              }
            : {
                threshold: "",
                online: true,
                inStore: true,
                fullTokens: RetailerFullToken[0],
                partTokens: RetailerPartToken[0],
                tokenPercentage: null
              },
        brandHex: initialValue.brandHex || "",
        category:
          RetailerTypesOptions.find(
            item => item.value === initialValue.category
          ) || RetailerTypesOptions[0],
        top10:
          initialValue.top10 && initialValue.top10 !== "none"
            ? {
                value: initialValue.top10,
                label: initialValue.top10
              }
            : Top10Options[0],
        offerRedemptionType:
          OfferRedemptionTypeOptions.find(
            option => option.value === initialValue.offerRedemptionType
          ) || OfferRedemptionTypeOptions[1]
      });
    }
  }

  onChangeHandler = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  addOffer = () => {
    const {
      provider,
      membershipBenefit,
      info,
      logo_img,
      bg_img,
      category,
      brandHex,
      top10,
      offerRedemptionType
    } = this.state;
    const { addOffer } = this.props;
    addOffer(
      provider,
      membershipBenefit,
      {
        ...info,
        partTokens: info.partTokens.value,
        fullTokens: info.fullTokens.value
      },
      logo_img,
      bg_img,
      category.value,
      brandHex,
      top10.value,
      offerRedemptionType.value
    );
    this.setState({
      provider: "",
      membershipBenefit: "",
      info: {
        threshold: "",
        online: true,
        inStore: true,
        fullTokens: RetailerFullToken[0],
        partTokens: RetailerPartToken[0],
        tokenPercentage: null
      },
      brandHex: "",
      category: RetailerTypesOptions[0],
      top10: Top10Options[0],
      offerRedemptionType: OfferRedemptionTypeOptions[1]
    });
  };

  selectedFile = e => {
    let _this = this;
    let id = e.target.id;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function(data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function(canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
          },
          {
            canvas: true,
            orientation: orientation
          }
        );
      });
    }
  };

  handleChangeTop10 = top10 => {
    this.setState({ top10 });
  };

  handleChangeType = category => {
    this.setState({ category });
  };

  handleOfferRedemption = offerRedemptionType => {
    this.setState({ offerRedemptionType });
  };

  handleInputChange = name => event => {
    const { info } = this.state;
    this.setState(
      {
        info: {
          ...info,
          [name]: event.target.value
        }
      },
      () => {
        this.calcPercentage();
      }
    );
  };

  handleChangeSelectToken = tokenName => newValue => {
    const { info } = this.state;
    this.setState(
      {
        info: {
          ...info,
          [tokenName]: newValue
        }
      },
      () => {
        this.calcPercentage();
      }
    );
  };

  handleChangeChk = name => event => {
    const { info } = this.state;
    this.setState({
      info: {
        ...info,
        [name]: event.target.checked
      }
    });
  };

  calcPercentage = () => {
    const { info } = this.state;

    this.setState({
      info: {
        ...info,
        tokenPercentage: this.calcPercentageEach(
          info.threshold,
          info.fullTokens.value,
          info.partTokens.value
        )
      }
    });
  };

  calcPercentageEach = (threshold, fullTokens, partTokens) => {
    if (threshold) {
      return Math.round(((fullTokens + partTokens) * 1000) / threshold) / 10;
    }

    return null;
  };

  render() {
    const {
      provider,
      info,
      brandHex,
      category,
      top10,
      offerRedemptionType
    } = this.state;
    const { offers, id } = this.props;

    const top10OptionsAvailable = Top10Options.filter(option => {
      if (option.value === "none") {
        return true;
      }

      const keys = _.keys(offers);
      return !keys.find(
        key => offers[key] && offers[key].top10 === option.value
      );
    });
    return (
      <div
        className="modal fade add-offer-modal"
        id={id ? `add_offer_${id}` : "add_offer"}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Offer</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <label>Offer Provider Name</label>
                <input
                  type="text"
                  className="form-control form-control-md form-control-alt"
                  name="provider"
                  placeholder="Input brand name here..."
                  onChange={this.onChangeHandler}
                  value={provider}
                />
              </div>
              <div className="info-container">
                <label>Offer Info</label>
                <div className="info-details-container">
                  <div className="threshold-container">
                    <div className="input-group">
                      <div className="prefix">£</div>
                      <input
                        type="number"
                        className="form-control form-control-md form-control-alt threshold"
                        placeholder="Spend threshold"
                        onChange={this.handleInputChange("threshold")}
                        value={info.threshold}
                      />
                    </div>
                    <div className="row_item">
                      <input
                        type="checkbox"
                        checked={info.online}
                        onChange={this.handleChangeChk("online")}
                      />
                      <p>Online</p>
                    </div>
                    <div className="row_item">
                      <input
                        type="checkbox"
                        checked={info.inStore}
                        onChange={this.handleChangeChk("inStore")}
                      />
                      <p>In store</p>
                    </div>
                  </div>
                  <div className="full-token-container">
                    <div className="token-select-container">
                      <Select
                        placeholder="Full tokens (N/A, 1, etc)"
                        value={info.fullTokens}
                        onChange={this.handleChangeSelectToken("fullTokens")}
                        options={RetailerFullToken}
                      />
                    </div>
                    <div className="token-select-container">
                      <Select
                        placeholder="Part tokens (0, 0.25, etc)"
                        value={info.partTokens}
                        onChange={this.handleChangeSelectToken("partTokens")}
                        options={RetailerPartToken}
                      />
                    </div>
                    <div className="form-control form-control-md form-control-alt percentage">
                      {info.tokenPercentage}%
                    </div>
                  </div>
                </div>
              </div>
              <div className="logo-container">
                <p htmlFor="logo-input">Logo</p>
                <input
                  type="file"
                  id="logo_img"
                  accept="image/*"
                  onChange={this.selectedFile}
                />
              </div>
              <div className="logo-container">
                <p htmlFor="bkg-input">Background Image</p>
                <input
                  type="file"
                  id="bg_img"
                  accept="image/*"
                  onChange={this.selectedFile}
                />
              </div>
              <div className="form-group">
                <label>Brand hex</label>
                <input
                  type="text"
                  className="form-control form-control-md form-control-alt"
                  name="brandHex"
                  placeholder="Input hex code..."
                  onChange={this.onChangeHandler}
                  value={brandHex}
                />
              </div>
              <div className="form-group">
                <label>Offer type</label>
                <Select
                  placeholder="Retailer type"
                  value={category}
                  onChange={this.handleChangeType}
                  options={RetailerTypesOptions}
                />
              </div>
              <div className="form-group">
                <label>Offer redemption selection</label>
                <Select
                  placeholder="Offer redemption selection"
                  value={offerRedemptionType}
                  onChange={this.handleOfferRedemption}
                  options={OfferRedemptionTypeOptions}
                />
              </div>
              <div className="form-group">
                <label>Top 10 offer</label>
                <Select
                  placeholder="Top 10 offer"
                  value={top10}
                  onChange={this.handleChangeTop10}
                  options={top10OptionsAvailable}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.addOffer}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddOfferModal;



// WEBPACK FOOTER //
// ./src/components/AddOfferModal/index.js